import { LtiRequestType } from '../../Entities';

export type Lti1p3LaunchParams = {
  apiUrl: string;
  spaceId: string;
  clientId: string;
  type: LtiRequestType;
  sessionToken: string;
  userId: string;
  resourceLinkId?: string;
};

export const lti1p3Launch = async ({
  apiUrl,
  spaceId,
  clientId,
  type,
  sessionToken,
  userId,
  resourceLinkId,
}: Lti1p3LaunchParams): Promise<string> => {
  const result = await fetch(`${apiUrl}/lti/1p3/start`, {
    method: 'post',
    body: JSON.stringify({
      spaceId,
      clientId,
      type,
      resourceLinkId,
    }),
    headers: {
      'Content-Type': 'application/json',
      'x-session-token': sessionToken,
      'x-user-id': userId,
    },
  });
  const { ltiSessionToken } = await result.json();
  return ltiSessionToken;
};
